import React from 'react';
import CurrencyLabel from 'Utils/CurrencyLabel';
import BillingLinesTable from 'Components/cart/BillingLinesTable';
import DetailedAmountPaid from 'Components/events/DetailedAmountPaid';
import DetailedAmountRefunded from 'Components/events/DetailedAmountRefunded';
import LoadingSpinner from 'Utils/LoadingSpinner';

const BillingAndPayments = ({ rental }) => {
  if (!rental) return <LoadingSpinner />;

  return (
    <div>
      {rental.billingLines && (
        <BillingLinesTable
          billingLines={rental.billingLines}
          rentalSetting={rental.rentalSetting}
        />
      )}
      <div className='billingDetails'>
        {rental.payments &&
          rental.payments.length > 0 &&
          rental.payments.map((payment) => {
            if (
              payment.status !== 'Authorized' &&
              payment.status !== 'Success'
            ) {
              return (
                <DetailedAmountPaid
                  key={payment.id}
                  payment={payment}
                  ownerView={false}
                  recurringTransactionInfo={rental.recurringTransactionInfo}
                />
              );
            }
          })}
        {rental.refunds &&
          rental.refunds.length > 0 &&
          rental.refunds.map((refund) => (
            <DetailedAmountRefunded
              key={refund.id}
              refund={refund}
              ownerView={false}
            />
          ))}
        {rental.amountRemaining != null && (
          <div className='subtotal'>
            <label>Amount Remaining</label>
            <CurrencyLabel value={rental.amountRemaining} />
          </div>
        )}
      </div>
    </div>
  );
};

export default BillingAndPayments;
